import { render, staticRenderFns } from "./YA_Login.vue?vue&type=template&id=1d360781&scoped=true"
import script from "./YA_Login.vue?vue&type=script&lang=js"
export * from "./YA_Login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d360781",
  null
  
)

export default component.exports